<template>
  <div class="auth-loading">
    <div class="auth-loading__spinner"></div>
    <p class="auth-loading__text">{{ $t("auth-loading") }}</p>
  </div>
</template>

<script>
export default {
  name: "AuthLoadingPage",
}
</script>

<style scoped>
.auth-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: var(--background-color);
  gap: 16px;
}

.auth-loading__spinner {
  width: 36px;
  height: 36px;
  border: 3px solid var(--hr-color);
  border-top-color: #007aff;
  border-radius: 50%;
  animation: auth-spin 0.8s linear infinite;
}

.auth-loading__text {
  font-family: "SF Pro Text", sans-serif;
  font-size: 14px;
  color: var(--text-color2);
}

@keyframes auth-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
